import React from 'react';
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { useSecurityHeaders } from '@/hooks/useSecurityHeaders';
import { ThemeProvider } from "next-themes";

// Initialize security headers
function AppWithSecurity() {
  useSecurityHeaders({
    enableCSP: true,
    enableXFrameOptions: true,
    enableXContentTypeOptions: true,
    enableReferrerPolicy: true
  });
  
  return <App />;
}

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
    <AppWithSecurity />
  </ThemeProvider>
);
